import { cn } from '@/shadcn-ui/utils';

interface FormLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export default function FormLayout({ children, className }: FormLayoutProps) {
  return (
    <div className="flex-start flex w-full max-w-full flex-col content-center items-center">
      <div className={cn('w-full md:max-w-[420px]', className)}>{children}</div>
    </div>
  );
}
